//* We put enums in their own file so we can use `import type` in cases where
//* we only need the type definition and we can use `import` in cases where we
//* need to use the value, thus letting the compiler exclude type-only files
//* like the `types.ts` file in this folder.
export enum VisibilityFilters {
  ALL = "ALL",
  COMPLETED = "COMPLETED",
  ACTIVE = "ACTIVE",
}
